import { ChannelService, ChannelStateContainer, } from "@volkswagen-onehub/integrator2fa-communication";
import { compareArray } from "./compare-array";
const compareSearchTermModel = (s1, s2) => {
    if (Boolean(s1) !== Boolean(s2)) {
        return false;
    }
    if (!s1 || !s2) {
        return false;
    }
    if (!compareArray(s1.searchTerms, s2.searchTerms)) {
        return false;
    }
    return true;
};
const compareSearchResultModel = (s1, s2) => {
    if (Boolean(s1) !== Boolean(s2)) {
        return false;
    }
    if (!s1 || !s2) {
        return false;
    }
    if (!compareArray(s1.searchTerms, s2.searchTerms)) {
        return false;
    }
    if (compareArray(Object.keys(s1.matchedSearchTerms).sort(), Object.keys(s2.matchedSearchTerms).sort())) {
        return false;
    }
    if (Object.keys(s1.matchedSearchTerms).find((e1) => s2.matchedSearchTerms[e1] !== s1.matchedSearchTerms[e1])) {
        return false;
    }
    return true;
};
export function defineWebsiteSearchChannelService() {
    return {
        id: "website-search-channel-service",
        optionalDependencies: { featureServices: { "s2:logger": "^1.0.0" } },
        dependencies: {
            featureServices: {},
        },
        create: () => {
            const searchTermContainer = new ChannelStateContainer(compareSearchTermModel);
            const searchResultContainer = new ChannelStateContainer(compareSearchResultModel);
            return {
                "1.0.0": (consumerId) => {
                    const searchTermFeatureService = new ChannelService(consumerId, searchTermContainer);
                    const searchResultFeatureService = new ChannelService(consumerId, searchResultContainer);
                    const unbind = () => {
                        searchTermFeatureService.cleanUp();
                        searchResultFeatureService.cleanUp();
                    };
                    return {
                        featureService: createWebsiteSearchChannelServiceImpl(searchTermFeatureService, searchResultFeatureService),
                        unbind,
                    };
                },
            };
        },
    };
}
function createWebsiteSearchChannelServiceImpl(searchTermFeatureService, searchResultService) {
    return {
        integrator: {
            tuneResult: (channelId) => {
                return searchResultService.tune(channelId);
            },
            tuneTerm: (...channelIds) => {
                return searchTermFeatureService.tune(...channelIds);
            },
        },
        client: {
            set: searchResultService.set.bind(searchResultService),
            get: searchTermFeatureService.get.bind(searchTermFeatureService),
            listen: searchTermFeatureService.listen.bind(searchTermFeatureService),
        },
    };
}
